<script>
  let { skeletonLength = Math.floor(Math.random() * 3) } = $props();
</script>

<div class="relative w-full shadow-y-sm rounded-sm bg-white">
  <div class="w-full px-3 pt-2 flex flex-col">
    <div
      class="h-4 mt-1 mb-2 skeleton-gradient animated-skeleton"
      class:w-72={skeletonLength === 0}
      class:w-53={skeletonLength === 1}
      class:w-46={skeletonLength === 2}
    ></div>
    <div
      class="h-3 mb-1 skeleton-gradient animated-skeleton animation-delay-150"
      class:w-36={skeletonLength === 0}
      class:w-75={skeletonLength === 1}
      class:w-65={skeletonLength === 2}
    ></div>
  </div>
  <div class="flex justify-center py-1 bg-gray-pale">
    <div class="w-1/3 h-3 my-1 bg-gray-light-silver"></div>
  </div>
</div>
